/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Duration_MinutesInputs */

const en_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const fr_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const de_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const it_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const ru_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} мин`)
};

const es_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const zh_cn2_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 分钟`)
};

const ja_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes}分`)
};

const hi_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} मिनट`)
};

const pt_pt2_duration_minutes = /** @type {(inputs: Duration_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "{minutes} min" |
*
* @param {Duration_MinutesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const duration_minutes = /** @type {((inputs: Duration_MinutesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duration_MinutesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_duration_minutes(inputs)
	if (locale === "de") return de_duration_minutes(inputs)
	if (locale === "it") return it_duration_minutes(inputs)
	if (locale === "ru") return ru_duration_minutes(inputs)
	if (locale === "es") return es_duration_minutes(inputs)
	if (locale === "zh-CN") return zh_cn2_duration_minutes(inputs)
	if (locale === "ja") return ja_duration_minutes(inputs)
	if (locale === "hi") return hi_duration_minutes(inputs)
	if (locale === "pt-PT") return pt_pt2_duration_minutes(inputs)
	return en_duration_minutes(inputs)
});